import { useState } from 'react';
import { WorkbookPage, SectionTitle, Callout } from '@/components/WorkbookPage';
import { Shield, TrendingUp } from 'lucide-react';

export const EmergencyTrackerPage = () => {
  const [entries, setEntries] = useState([
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
    { date: '', deposit: '', withdrawal: '', balance: '', notes: '' },
  ]);
  
  const updateEntry = (index, field, value) => {
    const newEntries = [...entries];
    newEntries[index] = { ...newEntries[index], [field]: value };
    setEntries(newEntries);
  };
  
  return (
    <WorkbookPage pageId="emergency-tracker" prevPage="credit-checklist" nextPage="irregular-planner">
      <header className="mb-10">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="h-6 w-6 text-primary" />
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-foreground">
            Emergency Fund Tracker
          </h1>
        </div>
        <p className="text-muted-foreground">
          Track your progress building financial security
        </p>
      </header>
      
      {/* Goal Settings */}
      <div className="grid md:grid-cols-3 gap-4 mb-8">
        <div className="bg-primary/10 rounded-xl p-5 text-center">
          <p className="text-sm text-muted-foreground mb-2">First Goal</p>
          <input
            type="text"
            className="w-full bg-transparent text-2xl font-bold text-center focus:outline-none"
            placeholder="$500"
          />
        </div>
        <div className="bg-success/10 rounded-xl p-5 text-center">
          <p className="text-sm text-muted-foreground mb-2">Ultimate Goal</p>
          <input
            type="text"
            className="w-full bg-transparent text-2xl font-bold text-center focus:outline-none"
            placeholder="$___"
          />
        </div>
        <div className="bg-accent/10 rounded-xl p-5 text-center">
          <p className="text-sm text-muted-foreground mb-2">Current Balance</p>
          <input
            type="text"
            className="w-full bg-transparent text-2xl font-bold text-center focus:outline-none"
            placeholder="$___"
          />
        </div>
      </div>
      
      <Callout type="info">
        <strong>Remember:</strong> Only use this fund for true emergencies—unexpected car repairs, 
        medical bills, job loss. Not for planned expenses or wants.
      </Callout>
      
      <SectionTitle>Transaction Log</SectionTitle>
      
      <div className="overflow-x-auto my-6">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-border">
              <th className="text-left py-3 pr-2">Date</th>
              <th className="text-right py-3 px-2 text-success">Deposit (+)</th>
              <th className="text-right py-3 px-2 text-destructive">Withdrawal (-)</th>
              <th className="text-right py-3 px-2">Balance</th>
              <th className="text-left py-3 pl-2">Notes</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry, index) => (
              <tr key={index} className="border-b border-border/50">
                <td className="py-2 pr-2">
                  <input
                    type="text"
                    className="w-full bg-muted/30 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="MM/DD"
                    value={entry.date}
                    onChange={(e) => updateEntry(index, 'date', e.target.value)}
                  />
                </td>
                <td className="py-2 px-2">
                  <input
                    type="text"
                    className="w-full text-right bg-success/5 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-success"
                    placeholder="$___"
                    value={entry.deposit}
                    onChange={(e) => updateEntry(index, 'deposit', e.target.value)}
                  />
                </td>
                <td className="py-2 px-2">
                  <input
                    type="text"
                    className="w-full text-right bg-destructive/5 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-destructive"
                    placeholder="$___"
                    value={entry.withdrawal}
                    onChange={(e) => updateEntry(index, 'withdrawal', e.target.value)}
                  />
                </td>
                <td className="py-2 px-2">
                  <input
                    type="text"
                    className="w-full text-right bg-muted/30 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="$___"
                    value={entry.balance}
                    onChange={(e) => updateEntry(index, 'balance', e.target.value)}
                  />
                </td>
                <td className="py-2 pl-2">
                  <input
                    type="text"
                    className="w-full bg-muted/30 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary"
                    placeholder="Reason"
                    value={entry.notes}
                    onChange={(e) => updateEntry(index, 'notes', e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <TrendingUp className="h-4 w-4 text-success" />
        <span>Even small deposits add up over time. Stay consistent!</span>
      </div>
    </WorkbookPage>
  );
};
